import { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { ethers } from 'ethers';

import { abi, contractAddress } from '../constants/endPoints';


function PayEmployeeModal(props: any) {
    const { show, onHide, address } = props; 
  const [amount, setAmount] = useState(0);
  
  function listenForTransactionMine(transactionResponse: any, provider: any) {
    console.log(`Mining ${transactionResponse.hash}`)
    return new Promise((resolve, reject) => {
        provider.once(transactionResponse.hash, (transactionReceipt: any) => {
            console.log(
                `Completed with ${transactionReceipt.confirmations} confirmations. `
            )
            resolve(1)
        })
    })
}
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    console.log(amount);
    // cast amount to int
    // const amountInt = ethers.utils.parseEther(amount);
    // const toBeSent: Number = parseInt(amount)
    if (typeof window.ethereum !== "undefined") {
        e.preventDefault();
        try {
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            console.log(signer)
            const contract = new ethers.Contract(contractAddress, abi, signer);
            const transactionRsponse = await contract.payEmployee(address, amount, {
                gasLimit: 10000000,
                nonce: undefined,
            });
            await listenForTransactionMine(transactionRsponse, provider)
            console.log(transactionRsponse)
        } catch (error) {
            console.log(error);
        }
      
  
        // const newEmployee = {
        //   name: employeeName,
        //   address: employeeAddress,
        //   latitude: employeeLatitude,
        //   longtitude: employeeLogntitude,
        //   timeStamp
        // };
        // props.onCreatePressed(newEmployee);
        // window.location.href = '/';
      }
    onHide();
    alert('Employee Paid!');
    // window.location.reload(true);
  };
  return (
    <Modal show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Pay Employee</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Adderss</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter amount"
              value={address}
            //   onChange={(e: any) => setAmount(e.target.value)}
              autoFocus
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter amount"
              onChange={(e: any) => setAmount(parseInt(e.target.value))}
              autoFocus
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button
          type="submit"
          variant="warning"
          onClick={(e) => handleSubmit(e)}
        >
          Pay Employee
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PayEmployeeModal;
